function getDatesTranslatedByLanguage(userLanguage, estimatedDeliveryDates, userRegion) {
  const [minimum, maximum] = estimatedDeliveryDates.split('-').map(Number);
  
  const today = new Date();

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + minimum);
  
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + maximum);

  if(isSunday(minDate)) {
    minDate.setDate(minDate.getDate() + 1);
    
    if(minDate.getTime() === maxDate.getTime()) {
      maxDate.setDate(maxDate.getDate() + 1);
    }
  }

  if(isSunday(maxDate)) {
    maxDate.setDate(maxDate.getDate() + 1);
  }
  
  const optionsMin = { day: 'numeric' };
  const optionsMax = { day: 'numeric' };

  if(userLanguage == 'fr') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'es') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'long';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'de') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'it') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'long';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'nl') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else
  {
    if (minDate.getMonth() == maxDate.getMonth()) {
    optionsMin.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }

  const minDateFormatted = minDate.toLocaleDateString(userLanguage, optionsMin);
  const maxDateFormatted = maxDate.toLocaleDateString(userLanguage, optionsMax);

  if (userLanguage === 'fr') {
    return `Livraison prévue entre le <strong>${minDateFormatted}</strong> et le <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'es') {
    return `Entrega estimada entre el <strong>${minDateFormatted}</strong> y el <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'de') {
    return `Lieferung zwischen dem <strong>${minDateFormatted}</strong> und <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'it') {
    return `Consegna prevista tra il <strong>${minDateFormatted}</strong> e il <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'nl') {
    return `Verwachte levering tussen <strong>${minDateFormatted}</strong> en <strong>${maxDateFormatted}</strong>`;
  } else {
    return `Estimated delivery between <strong>${minDateFormatted}</strong> and <strong>${maxDateFormatted}</strong>`;
  }
}

function isSunday(date) {
  return date.getDay() === 0;
}

function getShippingOfferConditions(userLanguage, shippingCost, offerAmount) {

  
  if (userLanguage === 'fr') {
    return `Frais d'expédition <strong>offerts dès ${offerAmount}</strong> d'achat`;
  } else if (userLanguage === 'es') {
    return `Envío <strong>gratis a partir de ${offerAmount}</strong> de compra`;
  } else if (userLanguage === 'de') {
    return `<strong>Kostenloser Versand</strong> ab ${offerAmount}`;
  } else if (userLanguage === 'it') {
    return `<strong>Spedizione gratuita</strong> da ${offerAmount}`;
  } else if (userLanguage === 'nl') {
    return `<strong>Gratis verzending</strong> vanaf ${offerAmount}`;
  } else {
    return `<strong>Free shipping</strong> on orders over ${offerAmount}`;
  }
}

function getShippingOfferBanner(userLanguage, countryInfo) {

  let currencySymbol = countryInfo.symbol;
  let offerAmount = countryInfo.offer;
  let countryFlag = countryInfo.flag;

  
  if (userLanguage === 'fr') {
    return `Livraison <strong>offerte</strong> dès ${offerAmount} ${currencySymbol} d'achat ${countryFlag}`;
  } else if (userLanguage === 'es') {
    return `Envío <strong>gratis</strong> a partir de ${offerAmount}${currencySymbol} de compra ${countryFlag}`;
  } else if (userLanguage === 'de') {
    return `<strong>Kostenloser Versand</strong> ab ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else if (userLanguage === 'it') {
    return `<strong>Spedizione gratuita</strong> da ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else if (userLanguage === 'nl') {
    return `<strong>Gratis verzending</strong> vanaf ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else {
    let formattedOfferAmount = offerAmount.replace(',', '.');

    formattedOfferAmount = formattedOfferAmount.replace(' ', ',');
    return `${countryFlag} <strong>Free shipping</strong> on orders over ${currencySymbol}${offerAmount} ${countryFlag}`;
  }
}
